import React from "react";
import "./Footer.css";
import logo from "../assets/logos/11-Photoroom.png";

import {
  FaInstagram,
  FaFacebookF,
  FaYoutube,
  FaLinkedinIn,
  FaArrowUp,
  FaWhatsapp,
  FaPhoneAlt,
} from "react-icons/fa";

function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="footer">

      {/* BACKGROUND GLOWS */}
      <div className="footer-glow footer-glow1"></div>
      <div className="footer-glow footer-glow2"></div>

      <div className="footer-container">

        {/* TOP BRAND AREA */}

        <div className="footer-brand">

          <div className="footer-logo-wrap">

            <img
              src={logo}
              alt="The Culture Capsule"
              className="footer-logo"
            />

          </div>

          <p className="footer-tagline">
            Crafting cinematic stories, bold identities,
            <br />
            and digital experiences that people remember.
          </p>

        </div>


        {/* DIVIDER */}

        <div className="footer-divider">
          <span></span>
          <small>THE CULTURE CAPSULE</small>
          <span></span>
        </div>


        {/* OFFICES */}

        <div className="footer-section-label">
          <span>FIND US</span>
          <div></div>
        </div>

        <div className="footer-addresses">

          <div className="address-card">

            <div className="address-number">
              01
            </div>

            <div className="address-icon">
              📍
            </div>

            <h4>
              Mumbai
            </h4>

            <p>
              Annapurna Building, 602 B,
              <br />
              Off New Link Rd, near Adarsh Nagar,
              <br />
              above Delicacy of China,
              <br />
              Andheri West, Mumbai,
              <br />
              Maharashtra 400102
            </p>

          </div>


          <div className="address-card">

            <div className="address-number">
              02
            </div>

            <div className="address-icon">
              📍
            </div>

            <h4>
              Nagpur
            </h4>

            <p>
              138, Dixit Nagar,
              <br />
              Nari Road,
              <br />
              Nagpur, 440026,
              <br />
              India
            </p>

          </div>

        </div>


        {/* SOCIAL */}

        <div className="footer-connect">

          <p>
            FOLLOW THE CONVERSATION
          </p>

          <div className="footer-socials">

            <a
              href="https://www.instagram.com/theculture_capsule?igsh=Y3V2NG5qYXY1Y2Vj"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <FaInstagram />
            </a>

            <a
              href="https://www.facebook.com/profile.php?id=61590533365189"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <FaFacebookF />
            </a>

            <a
              href="https://youtube.com/@theculturecapsule01?si=ZTPX7oAxshRvtCUr"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
            >
              <FaYoutube />
            </a>

            <a
              href="https://www.linkedin.com/company/123023938/admin/dashboard/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <FaLinkedinIn />
            </a>

          </div>

          <div className="footer-contact">

            <a
              href="tel:+917738995350"
              className="contact-item call-item"
            >
              <div className="contact-icon">
                <FaPhoneAlt />
              </div>

              <div>
                <span>CALL US</span>
                <strong>+91 77389 95350</strong>
              </div>
            </a>


            <a
              href="https://wa.me/917977744648"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-item whatsapp-item"
            >
              <div className="contact-icon">
                <FaWhatsapp />
              </div>

              <div>
                <span>WHATSAPP</span>
                <strong>+91 79777 44648</strong>
              </div>
            </a>

          </div>
        </div>


        {/* BIG CTA */}

        <div className="footer-cta">

          <p>
            HAVE A STORY TO TELL?
          </p>

          <h2>
            Let's make it
            <em> unforgettable.</em>
          </h2>

        </div>


        {/* BOTTOM */}

        <div className="footer-bottom">

          <div className="footer-copy">

            <span>
              © 2026 The Culture Capsule
            </span>

            <span>
              All rights reserved.
            </span>

          </div>


          {/* DEVELOPER CREDIT */}

          {/* <div className="footer-credit">

            <span>
              Designed & Developed by
            </span>

            <strong>
              Nirvati INFOTECH PVT. LTD.
            </strong>

          </div> */}


          <button
            className="footer-top-btn"
            onClick={scrollToTop}
            aria-label="Back to top"
          >
            <FaArrowUp />
          </button>

        </div>

      </div>

    </footer>
  );
}

export default Footer;